(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/ball-row-helper/assets/react/ball-rows-wrapper.js') >= 0) return;  svs.modules.push('/components/numbergames/ball-row-helper/assets/react/ball-rows-wrapper.js');

'use strict';

var _svs$numbergames$ball;
const _React = React,
  useRef = _React.useRef,
  useEffect = _React.useEffect,
  useLayoutEffect = _React.useLayoutEffect;
const getBallRowsEl = (_svs$numbergames$ball = svs.numbergames.ball_row_helper) === null || _svs$numbergames$ball === void 0 ? void 0 : _svs$numbergames$ball.getBallRowsEl;

const BallRowsWrapper = _ref => {
  let items = _ref.items,
    options = _ref.options,
    _ref$animateChanges = _ref.animateChanges,
    animateChanges = _ref$animateChanges === void 0 ? false : _ref$animateChanges;
  const ref = useRef();
  const rowsElRef = useRef();
  const ballRows = useRef();

  useLayoutEffect(() => {
    var _ballRows$current;
    const refCurrent = ref.current;
    if (!rowsElRef.current || ((_ballRows$current = ballRows.current) === null || _ballRows$current === void 0 || (_ballRows$current = _ballRows$current.rows) === null || _ballRows$current === void 0 ? void 0 : _ballRows$current.length) !== items.length || !animateChanges) {
      rowsElRef.current = getBallRowsEl({
        items,
        ballRowsOptions: options,
        beforeBallRender: balls => {
          ballRows.current = balls;
        }
      });
    }
    refCurrent.appendChild(rowsElRef.current);
    return () => {
      if (refCurrent) {
        refCurrent.innerHTML = '';
      }
    };
  }, [animateChanges, items, options]);

  useEffect(() => {
    if (animateChanges) {
      ballRows.current.rows.forEach((row, i) => {
        var _items$i$numbersExtra, _items$i;
        const numbers = items[i].numbers;
        const extraNumbers = (_items$i$numbersExtra = (_items$i = items[i]) === null || _items$i === void 0 ? void 0 : _items$i.numbersExtra) !== null && _items$i$numbersExtra !== void 0 ? _items$i$numbersExtra : [];
        row.prepare(numbers === null || numbers === void 0 ? void 0 : numbers.concat(extraNumbers));
      });
      ballRows.current.huxflux();
    }
  }, [items, animateChanges]);
  return React.createElement("div", {
    ref: ref
  });
};
svs.numbergames.ball_row_helper.BallRowsWrapper = BallRowsWrapper;

 })(window);